import { Heading, Stack, Text } from '@chakra-ui/react';
import { LockIcon } from './icons/Icon';
import { useI18n } from '../i18n/I18nContext';

export interface FeatureLockedProps {
    reason?: 'notReady' | 'noAccess';
    title?: string;
    description?: string;
}

export default function FeatureLocked({ reason = 'notReady', title, description }: FeatureLockedProps) {
    const { t } = useI18n();

    return (
        <Stack align='center' textAlign='center' gap={4} px={6} py={16} borderWidth='1px' borderRadius='lg' bg='bg.subtle'>
            <Stack align='center' justify='center' boxSize={14} borderRadius='full' bg='bg.muted' color='fg.muted'>
                <LockIcon size={28} aria-hidden='true' />
            </Stack>
            <Heading size='lg'>{title ?? t('common.featureLocked.title')}</Heading>
            <Text color='fg.muted' maxW='md'>{description ?? t(`common.featureLocked.${reason}`)}</Text>
        </Stack>
    );
}
